__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/afe4c96/packs/";